export function initArticleActions() {
  if (document.documentElement.dataset.webtenseArticleActionsInit) {
    return;
  }

  document.documentElement.dataset.webtenseArticleActionsInit = 'true';
  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!document.querySelectorAll('.actions-article').length) {
      return;
    }

    if (target.classList.contains('actions-article__item_like')) {
      target.classList.toggle('_active');
    }

    if (document.querySelector('.actions-article__item_share') && target.classList.contains('actions-article__item_share')) {
      target.classList.toggle('_active');
    }

    if (document.querySelector('.actions-article__item_share') && !target.closest('.actions-article__item_share')) {
      document.querySelector('.actions-article__item_share').classList.remove('_active');
    }
  });
}
